import { BASE_URL_API } from '@constants/base';
import { get, post } from '@utils/ajax';

/**
 * Shipping Request Service
 * Handles all shipping request related API calls
 */
const shippingRequestService = (() => {
    // Get shipping request list
    const getShippingRequestList = async params => {
        try {
            const response = await get(`${BASE_URL_API}/main/shippingRequest/list_api.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Bulk register shipping request
    const bulkRegisterShippingRequest = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/main/shippingRequest/approve_api.php`,
                {
                    method: 'f_create_multiple',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Get shipping request detail by ID
    const getShippingRequestDetail = async payload => {
        try {
            const response = await get(
                `${BASE_URL_API}/main/shippingRequest/detail_api.php`,
                {
                    method: 'info',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    const deleteShippingRequest = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/shippingRequest/delete_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    const approveReturnRequest = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/main/shippingRequest/approve_api.php`,
                {
                    method: 'accept_return',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    const rejectReturnRequest = async payload => {
        try {
            const response = await post(
                `${BASE_URL_API}/main/shippingRequest/approve_api.php`,
                {
                    method: 'reject_return',
                    ...payload
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    const approveShippingRequest = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/shippingRequest/approve_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    const updateShippedRequest = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/shippingRequest/update_order_shipped.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        getShippingRequestList,
        bulkRegisterShippingRequest,
        getShippingRequestDetail,
        deleteShippingRequest,
        approveReturnRequest,
        rejectReturnRequest,
        approveShippingRequest,
        updateShippedRequest
    };
})();

export default shippingRequestService;
